import { render, staticRenderFns } from "./InventoryTransfer.vue?vue&type=template&id=31dde012&scoped=true"
import script from "./InventoryTransfer.vue?vue&type=script&lang=js"
export * from "./InventoryTransfer.vue?vue&type=script&lang=js"
import style0 from "./InventoryTransfer.vue?vue&type=style&index=0&id=31dde012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dde012",
  null
  
)

export default component.exports